import { compact } from 'lodash-es'

export function PostHash() {
  return {
    lastPrevPost: null,
    lastCurrPost: null,
    lastNextPost: null,
    prevChanged: true,
    currChanged: true,
    nextChanged: true,
    prevPost: null,
    currPost: null,
    nextPost: null
  }
}

export function buildPostHash(currPost, posts) {
  if (!currPost) {
    return PostHash()
  }

  const currIndex = posts.indexOf(currPost)

  return {
    lastPrevPost: null,
    lastCurrPost: null,
    lastNextPost: null,
    prevChanged: true,
    currChanged: true,
    nextChanged: true,
    prevPost: posts[currIndex - 1] || null,
    currPost,
    nextPost: posts[currIndex + 1] || null
  }
}

export function mergePostHash(postHashA, postHashB) {
  postHashA.lastPrevPost = postHashA.prevPost
  postHashA.lastCurrPost = postHashA.currPost
  postHashA.lastNextPost = postHashA.nextPost

  postHashA.prevChanged = postHashA.prevPost !== postHashB.prevPost
  postHashA.currChanged = postHashA.currPost !== postHashB.currPost
  postHashA.nextChanged = postHashA.nextPost !== postHashB.nextPost

  postHashA.prevPost = postHashB.prevPost
  postHashA.currPost = postHashB.currPost
  postHashA.nextPost = postHashB.nextPost

  return postHashA
}

export function flushPostHash(postHash) {
  postHash.lastPrevPost = null
  postHash.lastCurrPost = null
  postHash.lastNextPost = null

  postHash.prevChanged = true
  postHash.currChanged = true
  postHash.nextChanged = true

  postHash.prevPost = null
  postHash.currPost = null
  postHash.nextPost = null

  return postHash
}

export function buildPostList(postHash) {
  return compact([
    postHash.prevPost,
    postHash.currPost,
    postHash.nextPost
  ])
}

export function isEqualPostHash(postHashA, postHashB) {
  return true
    && postHashA.prevPost === postHashB.prevPost
    && postHashA.currPost === postHashB.currPost
    && postHashA.nextPost === postHashB.nextPost
}
